import Main from './Main';
import 'bootstrap/dist/css/bootstrap.min.css';

import React from "react";
import { useGeolocated } from "react-geolocated";
//import MiTimer from './MiTimer';

function App() {

  //const time = new Date();
  //time.setSeconds(time.getSeconds() + 600); // 10 minutes timer

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  return !isGeolocationAvailable ? (
    <div>Su navegador no es compatible con la geolocalización</div>
  ) : !isGeolocationEnabled ? (
    <div>La geolocalización no está habilitada</div>
  ) : coords ? (
    <div id='WeatherTutiempo'>
      <Main coords={coords} />
    </div>
  ) : (
    <div>Obtener los datos de ubicació&hellip; </div>
  );
};

export default App;